import { AuditStatus } from '@arhs-fleetback/types/entities/audits';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { AUDIT_MANAGER, LEADERSHIP_ROLES } from 'constants/UserConstants';

export const EXPLODED_VIEW_DOT_SIZE = 16;

export const DASHBOARD_SOURCE = 'audits-dashboard';

export const SELECT_SOURCE = 'audits-select';

export const DETAILS_SOURCE = 'audit-details';

export const AUDIT_DRAWER_SOURCE = 'AUDIT_DRAWER';

export const DETAILS_SHARE_MODAL = 'audit-share-modal';

export const DRAWER_PREVIEW_SOURCE = 'drawer-preview';

export const LINK_AUDIT_MODAL_SOURCE = 'link-audit';

export const AUDIT_MANAGER_ROLES = [AUDIT_MANAGER, ...LEADERSHIP_ROLES];

export const DELETABLE_AUDIT_STATUSES = [AuditStatus.CLOSED, AuditStatus.DRAFT, AuditStatus.OPEN, AuditStatus.TO_START];
export const CloneOrigin = {
  AUDIT: 'AUDIT',
  LINKED_FILE: 'LINKED_FILE',
} as const;

export type CloneOrigin = (typeof CloneOrigin)[keyof typeof CloneOrigin];

export const AUDIT_STATUS_FILTER_LABEL: Record<string, React.ReactNode> = {
  [AuditStatus.DRAFT]: <FormattedMessage id="audito.model.builder.sections.header.status.DRAFT" defaultMessage="Draft" />,
  [AuditStatus.OPEN]: <FormattedMessage id="audito.audit_status.open" defaultMessage="Completed" />,
  [AuditStatus.TO_START]: <FormattedMessage id="audito.audit_status.to_start" defaultMessage="To start" />,
  [AuditStatus.CLOSED]: <FormattedMessage id="audito.audit_status.closed" defaultMessage="Archived" />,
};
